import React from "react";
import { cn } from "@/lib/utils";

/* RajinKerja identity — clean, bold, purposeful. Inline SVG mark (clock+tick),
   zero external assets. */
export const BrandMark = ({ className }) => (
  <svg viewBox="0 0 48 48" className={cn("h-9 w-9", className)} aria-hidden="true">
    <rect x="2" y="2" width="44" height="44" rx="12" className="fill-primary" />
    <circle cx="24" cy="24" r="14" className="fill-none stroke-white" strokeWidth="3" />
    <path d="M17 24.5l5 5 9.5-10" className="fill-none stroke-white" strokeWidth="3.4"
      strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const BrandWordmark = ({ className, markClassName }) => (
  <span className={cn("inline-flex items-center gap-2.5", className)}>
    <BrandMark className={markClassName} />
    <span className="font-semibold tracking-tight">
      Rajin<span className="text-primary">Kerja</span>
    </span>
  </span>
);
